import { AxiosRequestConfig } from 'axios';
import { api } from 'shared/api';
import { Activity } from 'shared/types';

import { ListOffer } from './types';

export interface FetchOffersResponse {
    items: ListOffer[];
    hasMorePages: boolean;
    totalOpenJobs: number;
    newThisWeek: number;
}

interface SendViewOfferActivityPayload {
    activityName: Activity;
    comment?: string;
}

// Note: Backend uses hardcoded 20 orders per page. Items per page will vary
// as one order can have multiple roles. Use hasMorePages for pagination.
export async function fetchOffers(pageNumber = 0) {
    const options: AxiosRequestConfig = {
        params: {
            pageNum: pageNumber,
            pageSize: 10
        }
    };

    return api.get<FetchOffersResponse>('orders/v2/byCandidate', undefined, options);
}

export async function sendViewOfferActivity(orderId: string) {
    const payload: SendViewOfferActivityPayload = { activityName: 'CandidateLinkOpened' };

    return api.post<SendViewOfferActivityPayload, void>(`Requests/${ orderId }/AddActivity`, payload);
}
